import { Directive, ElementRef, Renderer2, OnChanges, SimpleChanges, input, inject } from '@angular/core';

@Directive({
  selector: '[scrollToTop]'
})
export class ScrollToComponentTopDirective implements OnChanges {
  trigger = input<boolean>();

  private el = inject(ElementRef);
  private renderer = inject(Renderer2);

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['trigger'] && changes['trigger'].currentValue) {
      this.scrollToTop();
    }
  }

  private scrollToTop(): void {
    const element = this.el.nativeElement;

    if (element.scrollTop > 0) {
      this.renderer.setProperty(element, 'scrollTop', 0);
      return;
    }

    const scrollableParent = this.findScrollableParent(element);

    if (scrollableParent) {
      this.renderer.setProperty(scrollableParent, 'scrollTop', 0);
    } else {
      console.warn('No scrollable parent found for element:', element);
    }
  }

  private findScrollableParent(element: HTMLElement): HTMLElement | null {
    let parent = element.parentElement;
    while (parent) {
      const overflowY = getComputedStyle(parent).overflowY;
      if (overflowY === 'auto' || overflowY === 'scroll') {
        return parent;
      }
      parent = parent.parentElement;
    }
    return null;
  }
}
